import { httpClient } from '@/services/http/httpClient'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

type Params = {
  query: QueryParams
}

export type UserRankingResponse = {
  id: string
  name: string
  email: string
  points: number
  pointsBeforeReset: number
  image: string | null
  departament: string
  area: string
  rank: number
  likes: number
  comments: number
  createdIdeas: number
  approvedIdeas: number
  completedIdeas: number
  participationIdeas: number
  totalInteractions: number
}

export type GetRankingSimpleResponse = {
  usersRanking: UserRankingResponse[]
  paginate: {
    total: number
    page: number
    pages: number
    limit: number
  }
  hasResetInPeriod: boolean
}

export async function getRankingSimple({
  query,
}: Params): Promise<GetRankingSimpleResponse> {
  const queryParams = getQueryParams(query)
  const { data } = await httpClient.get(`/users/ranking?${queryParams}`)

  return {
    usersRanking: data.usersRanked,
    paginate: data.paginate,
    hasResetInPeriod: data.hasResetInPeriod ?? false,
  }
}
